
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-event/notifications",
      function () {
        return require("private-next-pages/create-event/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-event/notifications"])
      });
    }
  